import React, { Component } from "react";

import "./index.scss";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Intro from "../../components/Intro";
import Warning from "../../components/Warning";
import Logos from "./components/Logos";

import Faq from "./components/Faq";
import How from "./components/How";

import exame from "../../assets/logos/exame.svg";
import exameSelected from "../../assets/logos/exame-green.svg";
import vocesa from "../../assets/logos/vocesa.svg";
import vocesaSelected from "../../assets/logos/vocesa-green.svg";
import valor from "../../assets/logos/valor.svg";
import valorSelected from "../../assets/logos/valor-green.svg";
import startse from "../../assets/logos/startse.svg";
import startseSelected from "../../assets/logos/startse-green.svg";

class Home extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="lawyer">
        <Warning
          title="Recebeu um convite para negociar? Entre pelo link no próprio email e/ou SMS"
          area="Atendimento"
          phone="(21) 2391-1015"
        />
        <Header
          options={[
            { text: "Como funciona?", to: "How", reactScroll: true },
            { text: "Central de Ajuda", to: "Faq", reactScroll: true },
            { text: "Sou uma empresa", to: "/empresa" },
          ]}
          invite={true}
        />
        <Intro
          type="lawyer"
          title="Uma nova maneira de negociar seus processos."
          to="How"
        />
        <Logos
          items={[
            {
              text: '"Sem intermediários e audiências"',
              image: startse,
              imageSelected: startseSelected,
              href: "https://www.startse.com/noticia/startups/62285/startup-leva-tecnologia-para-o-setor-juridico-e-fecha-parceria-com-a-brasilprev",
              height: "35px",
            },
            {
              text: '"Fecha disputas em um dia"',
              image: vocesa,
              imageSelected: vocesaSelected,
              href: "https://exame.abril.com.br/carreira/veja-como-a-tecnologia-esta-mudando-o-trabalho-dos-advogados/",
              height: "35px",
            },
            {
              text: '"Destrava processos judiciais"',
              image: valor,
              imageSelected: valorSelected,
              href: "https://valor.globo.com/carreira/ensino-executivo/noticia/2019/02/21/escolas-querem-formar-advogados-para-o-futuro.ghtml",
              height: "35px",
            },
            {
              text: '"Viabliliza acordos rápidos"',
              image: exame,
              imageSelected: exameSelected,
              href: "https://exame.abril.com.br/negocios/dino/depois-das-fintechs-as-lawtechs-ja-mudam-o-setor-juridico-no-brasil-shtml/",
              height: "35px",
            },
          ]}
        />
        <How />
        <Faq />
        <Footer
          type="lawyer"
          options={[
            { text: "Como Funciona?", to: "How", reactScroll: true },
            { text: "Central de Ajuda", to: "Faq", reactScroll: true },
            { text: "Sou uma Empresa", to: "/empresa" },
            { text: "Termos de Uso", to: "/termos-de-uso" },
            { text: "Aviso de Privacidade", href: "/aviso-de-privacidade" },
          ]}
        />
      </div>
    );
  }
}

export default Home;
